import { Pipe } from "@angular/core";
import { Duration } from "luxon";

@Pipe({
    standalone: true,
    name: 'countdownFormat'
})
export class CountDownFormatPipe{
    
    transform(milliseconds: number): any {
        if( !milliseconds ){
            return '';
        }

        const date = Duration.fromMillis(milliseconds).shiftTo('days', 'hours', 'minutes', 'seconds').toObject();

        const days = date.days;
        const hours = date.hours;
        const minutes = date.minutes;
        const seconds = date.seconds;

        if (days) {
            const dFormat: string = getDayFormatByLcid();
            return `${days}${dFormat} ${hours}H`;
        } else if (hours) {
            return `${hours}H ${minutes}M`;
        } else if (minutes) {
            return `${minutes}M ${seconds}S`;
        } else {
            return `${seconds}S`;
        }
    }
}

// function to change days letter to correct language according to current lcid set
export function getDayFormatByLcid(): string {
    let lcid = localStorage.getItem('lcid');
    switch (lcid) {
      case '3084':
      case '1036':
        return 'J';
      default:
        return 'D';
    }
}